import { classifiersStore } from '@/store'
import { ClassifiersUtils } from '@/commons/utils/classifiers'
import { ApplicationDocument, Classifier } from '@/commons/types'
import {
    ApplicationDeliveryType,
    EXPEDITED_PLACE_OF_ISSUES
} from '@/commons/constants/application'

export class PlaceOfIssueUtils {
    static filteredPlaceOfIssues (isExpedited: boolean, placeOfIssues: Array<Classifier>): Array<Classifier> {
        if (!isExpedited) {
            return placeOfIssues || []
        } else {
            return placeOfIssues.filter((classifier: Classifier) =>
                EXPEDITED_PLACE_OF_ISSUES.indexOf(classifier.code) >= 0) || []
        }
    }

    static deliveryGroupLabelTranslationKey (key: string | null): string {
        return key ? `place_of_issue_group.${key}` : ''
    }

    static fetchPlaceOfIssue (document: ApplicationDocument, documentType: string): Classifier | undefined {
        if (!document || !document.delivery) {
            return undefined
        }

        const deliveryType = document.delivery.type
        let placesOfIssues = classifiersStore.localPlacesOfIssues

        if (deliveryType === ApplicationDeliveryType.FOREIGN_RETRIEVAL) {
            placesOfIssues = classifiersStore.foreignPlacesOfIssues
        } else if (deliveryType === ApplicationDeliveryType.CONSUL) {
            placesOfIssues = PlaceOfIssueUtils.getConsulPlaceOfIssues(documentType)
        } else if (deliveryType === ApplicationDeliveryType.STP_RETRIEVAL) {
            placesOfIssues = classifiersStore.stpPlacesOfIssues
        } else if (deliveryType === ApplicationDeliveryType.COURIER_RETRIEVAL) {
            placesOfIssues = classifiersStore.countries
        }

        return ClassifiersUtils.findClassifier(placesOfIssues, document.delivery.location)
    }

    static getConsulPlaceOfIssues (documentType: string): Array<Classifier> {
        if (documentType === 'citizenPassport') {
            return classifiersStore.consulPlacesOfIssuesCitizenPassport
        }
        return classifiersStore.consulPlacesOfIssuesIdCard
    }
}
